import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  settingsButton: {
    justifyContent: 'start',
    borderRadius: 10,
    '& svg': {
      transition: '0.1s fill',
      fill: theme.palette.secondary.light
    }
  },
  badge: {
    '& .MuiBadge-badge': {
      right: 28,
      top: 4
    }
  },
  workspaceBadge: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& .MuiBadge-badge': {
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: 'auto',
      marginBottom: 'auto',
      transform: 'none'
    },
    '&.invisible': {
      '& .MuiBadge-badge': {
        display: 'none'
      }
    }
  },
  listItem: {
    marginBottom: 8,
    transition: '0.1s background',
    padding: 16,
    borderRadius: 8,
    '& .MuiTypography-colorTextSecondary': {
      color: theme.palette.background.paper,
    },
    '& .sidebar-icon': {
      width: 32,
      height: 32,
      minWidth: 32,
      justifyContent: 'center',
      alignItems: 'center',
      transition: '0.1s background',
      marginRight: 24,
      '& svg': {
        transition: '0.1s fill',
        fill: theme.palette.background.default,
        width: '100%'
      }
    },
    '&:hover': {
      background: '#393939'
    },
    '&.Mui-selected': {
      background: '#393939',
      '& .MuiTypography-colorTextSecondary': {
        color: theme.palette.secondary.light,
      },
      '& .sidebar-icon': {
        '& svg': {
          fill: theme.palette.secondary.light
        }
      },
      '&:hover': {
        background: '#393939'
      }
    }
  },
  mainLogo: {
    width: 240,
    overflowX: 'hidden',
    display: 'flex',
    // justifyContent: 'center',
    paddingLeft: 0,
    paddingBottom: 32,
    paddingTop: 0,
    alignItems: 'center'
  },
  mainLogoImg: {
    width: 24,
    height: 24,
    borderRadius: '999rem',
    marginRight: 11,
    alignItems: 'center'
  },
  listElements: {
    paddingTop: 0,
    paddingBottom: 0
  },
  accountPrimary: {
    color: theme.palette.background.paper
  },
  accountSecondary: {
    color: '#A8A8A8!important'
  },
  account: {
    padding: 8,
    marginBottom: 0
  },
  avatar: {
    width: 48,
    height: 48,
    marginRight: 16,
    '& img': {
      height: 'auto'
    }
  },
  hide: {
    display: 'none'
  },
  logoText: {
    marginRight: 40,
    marginLeft: 4.5
  },
  moveLeft: {
    cursor: 'pointer'
  },
  moveRight: {
    cursor: 'pointer'
  },
  logoImage: {
    width: 48,
    height: 48
  },
  logo: {
    '& img': {
      height: 'auto'
    }
  },
  workspaceSelect: {
    width: '100%',
    color: '#FFF',
    paddingLeft: 0,
    fontSize: 20,
    letterSpacing: '0.25px',
    lineHeight: '21px',
    '& .MuiInput-input': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiAvatar-root': {
      marginRight: 16,
      width: 48,
      height: 48,
      '& img': {
        height: 'auto'
      }
    },
    '& .MuiSelect-icon': {
      fill: '#FFF'
    },
    '&.MuiInput-underline:after': {
      border: 'none!important'
    },
    '&.MuiInput-underline:before': {
      border: 'none!important'
    }
  },
  workspaceMenuItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '2px 8px',
    padding: '8px 10px',
    borderRadius: 10,
    letterSpacing: '0.25px',
    whiteSpace: 'normal',
    '&.Mui-selected, &.is-active': {
      backgroundColor: '#333333',
      boxShadow: 'inset 0 0 0 1px #4d4d4d'
    },
    '&.Mui-selected:hover, &.is-active:hover': {
      backgroundColor: '#3a3a3a'
    },
    '&:hover': {
      backgroundColor: '#2a2a2a'
    }
  },
  rowAvatar: {
    marginRight: 14,
    width: 40,
    height: 40,
    borderRadius: 10,
    flexShrink: 0,
    '& img': {
      height: 'auto'
    }
  },
  rowText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: 1
  },
  rowPrimary: {
    fontSize: 15,
    fontWeight: 700,
    lineHeight: '20px',
    color: '#FFF',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  rowSecondary: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#9e9e9e',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  rowCheck: {
    marginLeft: 12,
    fontSize: 20,
    color: '#ff8a80',
    flexShrink: 0
  },
  searchContainer: {
    padding: '12px 12px 8px',
    outline: 'none'
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFF',
      borderRadius: 10
    },
    '& .MuiOutlinedInput-input': {
      color: '#1a1a1a',
      fontSize: 16,
      padding: '10px 12px 10px 0'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent'
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2
    }
  },
  searchIcon: {
    color: '#8d8d8d',
    fontSize: 22
  },
  sectionLabel: {
    padding: '10px 16px 6px',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: '#8d8d8d'
  },
  pestelSection: {
    marginTop: 4,
    borderTop: '1px solid #333333'
  },
  pestelItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '2px 8px 4px',
    padding: '8px 10px',
    borderRadius: 10,
    cursor: 'pointer',
    backgroundColor: '#2a2a2a',
    '&:hover': {
      backgroundColor: '#333333'
    }
  },
  pestelAvatar: {
    marginRight: 14,
    width: 40,
    height: 40,
    borderRadius: 10,
    flexShrink: 0,
    backgroundColor: '#9e9d24',
    color: '#1a1a1a'
  },
  pestelSecondary: {
    fontSize: 13,
    lineHeight: '18px',
    fontStyle: 'italic',
    color: '#9e9e9e',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  workspaceSelectPopover: {
    '& .MuiPopover-paper': {
      backgroundColor: '#1e1e1e',
      color: '#FFF',
      borderRadius: 14,
      border: '1px solid #333333',
      minWidth: 320
    },
    '& .MuiMenu-list': {
      paddingTop: 0,
      paddingBottom: 8
    }
  },
  createWorkspaceContainer: {
    borderTop: '1px solid #333333'
  },
  createWorkspace: {
    color: '#A8A8A8',
    marginBottom: 0,
    paddingTop: 5.5,
    paddingBottom: 5.5,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: theme.palette.text.secondary,
      color: '#FFF'
    }
  },
  workplaceInput: {
    paddingLeft: 8
  }
}))

export default useStyles
